import { render, staticRenderFns } from "./Failure.vue?vue&type=template&id=72a1cbb5&scoped=true"
import script from "./Failure.vue?vue&type=script&lang=js"
export * from "./Failure.vue?vue&type=script&lang=js"
import style0 from "./Failure.vue?vue&type=style&index=0&id=72a1cbb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a1cbb5",
  null
  
)

export default component.exports